import React, { Component } from "react";
import axios from "axios";
import {
  Card,
  Row,
  Col,
  Progress,
  CardBody,
  // CardHeader,
  // CardFooter,
  Button,
} from "reactstrap";
import FaceIcon from "@material-ui/icons/Face";
import Chip from "@material-ui/core/Chip";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Tooltip from "@material-ui/core/Tooltip";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import DoneIcon from "@material-ui/icons/Done";
import AssignmentSharpIcon from "@material-ui/icons/AssignmentSharp";
import { toast } from "react-toastify";
class Startcourse extends Component {
  constructor(props) {
    super(props);
    const outcome = [];
    const courseDuration = [];

    const crsImage = [];
    const courseName = [];
    const courseDesc = [];
    const courseOwner = [];
    const outlinearray = [];

    const percentComplete = [];
    const videoStatus = [];
    const videoStatusid = [];

    this.state = {
      outcome,
      courseDuration,
      crsImage,
      courseName,
      courseDesc,
      courseOwner,
      outlinearray,
      percentComplete,
      videoStatus,
      videoStatusid,
      courseofflid: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (this.state.courseofflid !== localStorage.getItem("state")) {
      /// console.log("state  else if 1 ")

      this.getCoursedetails();
    }
  }

  componentDidMount() {
    this.getCoursedetails();
  }

  async getCoursedetails() {
    this.setState({ courseofflid: localStorage.getItem("state") });

    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    axios
      .post("LearnerCourse/courseoverview", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          // console.log(res.data);
          this.setState({
            courseName: res.data.coursename,
            courseOwner: res.data.courseowner,
            courseDesc: res.data.coursedesc,
            crsImage: res.data.crsimage,
            outlinearray: res.data.outlinearray,
            percentComplete: res.data.percentComplete,
            outcome: res.data.outcome,
            courseDuration: res.data.courseduration2,
            completedassignmentcnt: res.data.completedassignmentcnt,
            totalassignment: res.data.totalassignment,
            completedquizcount: res.data.completedquizcount,
            totalquiz: res.data.totalquiz,
            completedvideo: res.data.completedvideo,
            totalcoursevideos: res.data.totalcoursevideos,
            videoStatus: res.data.videostatus,
            videoStatusid: res.data.videostatusid,
          });

          // console.log("videoStatus  ==" + this.state.videoStatus);
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  render() {
    return (
      <div className="bg-color">
        <Row>
          <Col sm={8}>
            <Card>
              <CardBody className="tab-border-color">
                <Row>
                  <Col sm={5}>
                    <img
                      src={this.state.crsImage}
                      alt="course-img"
                      className="img-thumbnail card-overview-img"
                    ></img>
                  </Col>
                  <Col sm={6}>
                    <h5>{this.state.courseName}</h5>
                    Created By {this.state.courseOwner}
                    <br />
                    <Row className="p-3 test-cerated">
                      <Tooltip title="Assignment">
                        <span>
                          <Chip
                            icon={<AssignmentSharpIcon />}
                            label=""
                            clickable
                            className="assignment-chip"
                            color="primary"
                          />
                          {this.state.totalassignment <= 0 ? (
                            " NA"
                          ) : (
                            <>
                              &nbsp;{this.state.completedassignmentcnt} /{" "}
                              {this.state.totalassignment}
                            </>
                          )}{" "}
                        </span>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Quiz">
                        <span className="pl-3">
                          <Chip
                            className=" quiz-chip"
                            icon={
                              <img
                                src="/assets/images/icons/mcq1.svg"
                                height="20"
                                width="23"
                                alt="whyepn1"
                              />
                            }
                            label=""
                            clickable
                            color="primary"
                          />
                          {this.state.totalquiz <= 0 ? (
                            " NA"
                          ) : (
                            <>
                              &nbsp;{this.state.completedquizcount} /{" "}
                              {this.state.totalquiz}
                            </>
                          )}{" "}
                        </span>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Total Videos">
                        <span className="pl-3">
                          <Chip
                            className="total-video"
                            icon={<VideoLibraryIcon />}
                            label=""
                            clickable
                            color="primary"
                          />{" "}
                          {this.state.totalcoursevideos <= 0 ? (
                            " NA"
                          ) : (
                            <>
                              &nbsp; {this.state.completedvideo} /{" "}
                              {this.state.totalcoursevideos}
                            </>
                          )}{" "}
                        </span>
                      </Tooltip>
                    </Row>
                    <Progress
                      animated
                      color=""
                      value={this.state.percentComplete}
                    >
                      {this.state.percentComplete}
                    </Progress>
                    {/* {this.state.videoStatus === "found" ? (
                      <Button
                        color="primary"
                        style={{ borderRadius: 50 }}
                        className=" btn btn-getstarteds"
                        onClick={this.handleLogoutClick}
                      >
                        CONTINUE TO THE LECTURE
                      </Button>
                    ) : (
                      " "
                    )} */}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col sm={4}>
            <Card style={{ height: "242px" }}>
              <CardBody className="tab-border-color">
                <div id="style-6" class="desc scrollbar">
                  <span class="force-overflow">
                    <h5>Description </h5> <br />
                    {this.state.courseDesc}
                  </span>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <br />

        <br />
        <Row>
          <Col sm={12}>
            <div class="pull-left">
              <h5>Course Content </h5>
            </div>
            <div class="pull-right ">
              <span>
                <Tooltip title="Duration" aria-label="Duration">
                  <Chip
                    icon={<AccessTimeIcon />}
                    label={this.state.courseDuration + " (hh:mm:ss) "}
                    color="primary"
                    variant="outlined"
                  />
                </Tooltip>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
            </div>
            <br />
            <br />

            {this.state.outlinearray.map((item) => (
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{ marginTop: "10px" }}
                >
                  <Typography>{item.outlinenamee}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography style={{ backgroundColor: "rgb(238, 235, 248)" }}>
                    <ul class="syllabus-ul">
                      {item.topic.map((itemn, indexn) => (
                        <li> {itemn.topicname}</li>
                      ))}
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}

            <div class="outcome">
              <br />
              {this.state.outcome.length > 0 ? (
                <>
                  <h5> Learning OutComes/By the end of this course</h5>
                  <Card className="p-3">
                    <Col lg={12} >
                      <ul class="syllabus-ul mb-2">
                        {this.state.outcome.map((item) => (
                          <li  key={item.courseOutcomestmt}> {item.courseOutcomestmt} </li>
                        ))}
                      </ul>
                    </Col>
                  </Card>
                  <br />
                </>
              ) : (
                ""
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Startcourse;
